export default {"src":"/_next/static/media/CVS.8ba9c81d.svg","height":18,"width":18};